import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface ContentItem {
  label: string;
  items: string[];
}
const TOMOS: ContentItem[] = [{
  label: '🟢 TOMO 1 — Fundamentos para enseñar hockey infantil',
  items: ['🎯 Cómo enseñar hockey sin aburrir', '👦 Edades, niveles y objetivos reales', '👥 Cómo organizar grupos grandes', '🔥 Entrada en calor con palo y bocha', '🎲 Juegos de coordinación inicial', '🏑 Técnica básica de agarre', '➡️ Conducción simple y segura', '❌ Errores comunes en principiantes', '💬 Cómo corregir sin frustrar', '📋 Clase modelo de iniciación']
}, {
  label: '🔵 TOMO 2 — Técnica infantil: conducción, pase y recepción',
  items: ['🏑 Conducción frontal', '↔️ Conducción lateral', '🔄 Cambios de dirección', '🎯 Pase push', '💥 Pase barrido adaptado', '🧱 Recepción estática', '🏃‍♂️ Recepción en movimiento', '🎮 Control orientado', '🟠 Juegos técnicos por estaciones', '📈 Progresiones por edad']
}, {
  label: '🟡 TOMO 3 — Juegos, toma de decisiones y mini partidos',
  items: ['⚔️ Juegos 1 vs 1', '👥 Juegos 2 vs 1', '📍 Ocupación de espacios', '🤔 Decidir cuándo pasar', '🚀 Decidir cuándo conducir', '🏑 Mini partidos 3 vs 3', '🔁 Rotaciones simples', '🎯 Juegos con objetivos', '🏆 Competencias sanas', '📋 Clase modelo de decisiones']
}, {
  label: '🔴 TOMO 4 — Defensa, presión y recuperación',
  items: ['🛡️ Posición defensiva inicial', '👣 Cómo enseñar a marcar', '⚠️ Defensa sin contacto brusco', '🏑 Robo seguro de bocha', '🔥 Presión individual', '👥 Presión grupal básica', '🎮 Juegos defensivos', '🧩 Cómo evitar desorden', '❌ Correcciones frecuentes', '📋 Clase modelo defensiva']
}, {
  label: '🟣 TOMO 5 — Planificación mensual y anual para escuelitas',
  items: ['🗓️ Cómo planificar sin improvisar', '🎯 Objetivos por mes', '📆 Microciclos infantiles', '🌧️ Clases para lluvia o poco espacio', '🧺 Clases con poco material', '📊 Evaluación técnica simple', '👤 Seguimiento individual', '💬 Comunicación con padres', '🏆 Torneos internos', '📝 Plan anual editable']
}];
function AccordionItem({
  item,
  isOpen,
  onToggle
}: {
  item: ContentItem;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return <div className="rounded-xl overflow-hidden border bg-brand-card border-white/10 transition-colors" data-id="element-42">
      <button onClick={onToggle} className="w-full px-5 py-4 text-left flex items-center justify-between gap-4 focus:outline-none" data-id="element-43">
        <span className="font-bold text-brand-cream text-sm md:text-base" data-id="element-44">
          {item.label}
        </span>
        <ChevronDown className={`w-5 h-5 text-brand-accent flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-45" />
      </button>
      <AnimatePresence data-id="element-46">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-47">
            <ul className="px-5 pb-5 pt-1 space-y-2 border-t border-white/5" data-id="element-48">
              {item.items.map((line, i) => <li key={i} className="flex items-start gap-2 text-sm text-brand-cream/80" data-id="element-49">
                  <span data-id="element-50">{line}</span>
                </li>)}
            </ul>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function ContentBreakdownSection() {
  const [openIndex, setOpenIndex] = useState<string | null>(null);
  const toggle = (key: string) => setOpenIndex(openIndex === key ? null : key);
  return <section className="py-14 px-4 bg-brand-dark border-t border-white/5" data-id="element-51">
      <div className="max-w-4xl mx-auto" data-id="element-52">
        <div className="text-center mb-8" data-id="element-53">
          <h2 className="text-3xl md:text-5xl font-display text-brand-cream uppercase mb-3" data-id="element-54">
            🏑 Hockey Infantil <span className="accent-underline" data-id="element-55">360</span>
          </h2>
          <p className="text-lg text-brand-cream/80 max-w-2xl mx-auto" data-id="element-56">
            📚 Formación completa para profes, escuelitas y entrenadores de
            hockey infantil
          </p>
        </div>

        <div className="space-y-3" data-id="element-57">
          {TOMOS.map((tomo, i) => <AccordionItem key={`tomo-${i}`} item={tomo} isOpen={openIndex === `tomo-${i}`} onToggle={() => toggle(`tomo-${i}`)} data-id="element-58" />)}
        </div>
      </div>
    </section>;
}